import {
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Copy } from "react-bootstrap-icons";
import { db } from "../FirebaseConfig";
import uuid4 from "uuid4";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import axios from "axios";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import useChatClient from "../StatesStore/ChatClient";
import { UserAuth } from "../Context";
const CloneModal = ({
  list,
  listName,
  userId,
  shoppingListData,
  setShoppingListData,
  setLoading,
  BackgroundOnSvg,
  closeOtherDropdown,
  disable,
}) => {
  const [showModal, setShowModal] = useState(false);
  const { user } = UserAuth();
  const closeModal = () => setShowModal(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const client = useChatClient((state) => state.client);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  console.log("list", list);
  const cloneShoppingList = async () => {
    try {
      setLoading(true);
      const filteredShoppingLists = [];
      shoppingListData.filter((list) => {
        if (list.name.startsWith(listName))
          filteredShoppingLists.push(list?.name);
      });
      let index = 2;
      while (filteredShoppingLists.includes(`${listName} ${index}`)) {
        index++;
      }
      console.log("filteredShoppingLists, index", filteredShoppingLists, index);

      const newListId = uuid4();
      const newShopListRef = doc(
        db,
        "users",
        userId,
        "shoppingList",
        `${listName} ${index}`
      );
      const response = await axios.post(
        `${process.env.REACT_APP_GEMINI}/getTags`,
        {
          text: listName,
        }
      );

      const tags = response.data.result;
      const newShopListSnap = await getDoc(newShopListRef);
      if (!newShopListSnap.exists()) {
        await setDoc(newShopListRef, {
          dateCreated: serverTimestamp(),
          lastUpdated: serverTimestamp(),
          listId: newListId,
          listName: `${listName} ${index}`,
          visibility:
            list?.visibility !== "Friends" ? list?.visibility : "Public",
          tags: tags,
        });
        const newProductRef = collection(newShopListRef, "products");
        const productRef = collection(
          db,
          "users",
          userId,
          "shoppingList",
          list?.id,
          "products"
        );
        const productSnap = await getDocs(productRef);
        const products = productSnap.docs.map((doc) => doc?.id);
        await Promise.all(
          products?.map(async (product) => {
            const productRef = doc(newProductRef, product);
            await setDoc(productRef, {
              size: [],
              timestamp: serverTimestamp(),
              likeCount: 0,
              updatedAt: serverTimestamp(),
            });
          })
        );
        const newProductSnap = await getDocs(newProductRef);
        const newProducts = newProductSnap.docs.map((doc) => ({
          id: doc?.id,
          ...doc?.data(),
        }));
        const shoppingListDataArray = [
          ...shoppingListData,
          {
            id: `${listName} ${index}`,
            name: `${listName} ${index}`,
            products: newProducts,
            dateCreated: serverTimestamp(),
            lastUpdated: serverTimestamp(),
            listName: `${listName} ${index}`,
            listId: newListId,
            visibility:
              list?.visibility !== "Friends" ? list?.visibility : "Public",
            tags: tags,
          },
        ];
        shoppingListDataArray.sort((a, b) => b.lastUpdated - a.lastUpdated);
        setShoppingListData(shoppingListDataArray);
        await saveShoppingListToAlgolia(user, `${listName} ${index}`);
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, {
          shoppingListCount: increment(newProducts.length),
        });

        await createTeamChannel(newListId, `${listName} ${index}`, userId);
        toast.success(
          ` ${listName} Shopping List has been cloned as ${listName} ${index}`,
          toastOptions
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createTeamChannel = async (listId, listName, creatorId) => {
    try {
      const channel = await client.channel("team", listId, {
        name: listName,
        image: `https://ui-avatars.com/api/?name=${listName}`,
      });

      await channel.create();
      await channel.addMembers([
        { user_id: creatorId, channel_role: "channel_moderator" },
      ]);
      console.log("Team channel created successfully:", channel.id);
      return channel;
    } catch (error) {
      console.error("Error creating team channel:", error);
      throw error;
    }
  };
  return (
    <>
      <div
        className="d-flex align-items-center"
        style={{ gap: "12px" }}
        onClick={() => {
          if (!disable) {
            cloneShoppingList();
            closeOtherDropdown();
          } else {
            toast.warn("Add some products before making a copy!", toastOptions);
          }
        }}
      >
        {/* <BackgroundOnSvg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6667 13.9583H5.00001C4.39222 13.9583 3.80933 13.7168 3.37956 13.287C2.94979 12.8573 2.70834 12.2743 2.70834 11.6666V4.99992C2.70834 4.39213 2.94979 3.80924 3.37956 3.37947C3.80933 2.94969 4.39222 2.70825 5.00001 2.70825H11.6667C12.2744 2.70825 12.8573 2.94969 13.2871 3.37947C13.7169 3.80924 13.9583 4.39213 13.9583 4.99992V11.6666C13.9583 12.2743 13.7169 12.8573 13.2871 13.287C12.8573 13.7168 12.2744 13.9583 11.6667 13.9583ZM5.00001 3.95825C4.72374 3.95825 4.45879 4.068 4.26344 4.26335C4.06809 4.4587 3.95834 4.72365 3.95834 4.99992V11.6666C3.95834 11.9428 4.06809 12.2078 4.26344 12.4032C4.45879 12.5985 4.72374 12.7083 5.00001 12.7083H11.6667C11.9429 12.7083 12.2079 12.5985 12.4033 12.4032C12.5986 12.2078 12.7083 11.9428 12.7083 11.6666V4.99992C12.7083 4.72365 12.5986 4.4587 12.4033 4.26335C12.2079 4.068 11.9429 3.95825 11.6667 3.95825H5.00001Z"
              fill={disable ? "#c3c3c3" : "#667085"}
            />
            <path
              d="M15 17.2917H8.33332C7.72553 17.2917 7.14264 17.0503 6.71287 16.6205C6.2831 16.1907 6.04166 15.6078 6.04166 15.0001V13.3334H7.29166V15.0001C7.29166 15.2763 7.40141 15.5413 7.59676 15.7367C7.79211 15.932 8.05706 16.0417 8.33332 16.0417H15C15.2762 16.0417 15.5412 15.932 15.7366 15.7367C15.9319 15.5413 16.0417 15.2763 16.0417 15.0001V8.33341C16.0417 8.05715 15.9319 7.7922 15.7366 7.59685C15.5412 7.4015 15.2762 7.29175 15 7.29175H13.3333V6.04175H15C15.6077 6.04175 16.1907 6.28319 16.6204 6.71296C17.0502 7.14273 17.2917 7.72562 17.2917 8.33341V15.0001C17.2917 15.6078 17.0502 16.1907 16.6204 16.6205C16.1907 17.0503 15.6077 17.2917 15 17.2917Z"
              fill={disable ? "#c3c3c3" : "#667085"}
            />
          </svg>
        </BackgroundOnSvg> */}
        <svg
          style={{
            width: isSmallScreen ? "24px" : "28px",
            height: isSmallScreen ? "24px" : "28px",
          }}
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.33341 9.33332H8.40008C7.0933 9.33332 6.43989 9.33332 5.94077 9.58764C5.50172 9.81134 5.14477 10.1683 4.92107 10.6073C4.66675 11.1065 4.66675 11.7599 4.66675 13.0667V19.6C4.66675 20.9068 4.66675 21.5602 4.92107 22.0593C5.14477 22.4983 5.50172 22.8553 5.94077 23.079C6.43989 23.3333 7.0933 23.3333 8.40008 23.3333H14.9334C16.2402 23.3333 16.8936 23.3333 17.3927 23.079C17.8318 22.8553 18.1888 22.4983 18.4124 22.0593C18.6667 21.5602 18.6667 20.9068 18.6667 19.6V18.6667M13.0667 18.6667H19.6001C20.9069 18.6667 21.5603 18.6667 22.0594 18.4123C22.4984 18.1887 22.8554 17.8317 23.0791 17.3927C23.3334 16.8936 23.3334 16.2401 23.3334 14.9333V8.39999C23.3334 7.09321 23.3334 6.4398 23.0791 5.94068C22.8554 5.50163 22.4984 5.14467 22.0594 4.92098C21.5603 4.66666 20.9069 4.66666 19.6001 4.66666H13.0667C11.76 4.66666 11.1066 4.66666 10.6074 4.92098C10.1684 5.14467 9.81143 5.50163 9.58774 5.94068C9.33341 6.4398 9.33341 7.09319 9.33341 8.39999V14.9333C9.33341 16.2401 9.33341 16.8936 9.58774 17.3927C9.81143 17.8317 10.1684 18.1887 10.6074 18.4123C11.1066 18.6667 11.76 18.6667 13.0667 18.6667Z"
            stroke="#14191F"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        {/* <span
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "100%",
            letterSpacing: "0px",
            color: disable ? "#c3c3c3" : "#667085",
          }}
        >
          Make a Copy
        </span> */}
      </div>
      <Modal show={showModal} centered onHide={closeModal}>
        <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">Clone Shopping List</div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={closeModal}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <p>Are you sure you want to clone {listName}?</p>
          </div>
          <div className="d-flex flex-column gap-2 w-100">
            <Button
              className="rounded-3"
              variant="primary"
              onClick={async () => {
                cloneShoppingList();
                closeModal();
              }}
            >
              Clone
            </Button>
            <Button
              className="rounded-3"
              variant="danger-soft"
              onClick={closeModal}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CloneModal;
